import React from 'react'

export default class ErrorBoundary extends React.Component<{ children: React.ReactNode, onError: React.ReactNode }, { error: any | null }> {
  state = { error: null }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary.componentDidCatch', error, errorInfo)
  }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  render() {
    const { error } = this.state
    const { children, onError } = this.props

    return error ? onError : children
  }
}
